import * as types from './types';

export function loginStart() {
  return {
    type: types.LOGIN_START
  };
}
export function loginSuccess(res?: any) {
  return {
    type: types.LOGIN_SUCCESS,
    payload: res
  };
}
export function loginError(e: any) {
  return {
    type: types.LOGIN_ERROR,
    payload: e
  };
}

export function registerStart() {
  return {
    type: types.REGISTER_START
  };
}
export function registerSuccess(res?: any) {
  return {
    type: types.REGISTER_SUCCESS,
    payload: res
  };
}
export function registerError(e: any) {
  return {
    type: types.REGISTER_ERROR,
    payload: e
  };
}

export function showConfirmEmail(email: any) {
  return {
    type: types.SHOW_CONFIRM_EMAIL,
    payload: email
  }
}

// REGISTER ISSUER
export function registerIssuerStart() {
  return {
    type: types.REGISTER_ISSUER_START
  };
}
export function registerIssuerSuccess(res?: any) {
  return {
    type: types.REGISTER_ISSUER_SUCCESS,
    payload: res
  };
}
export function registerIssuerError(e: any) {
  return {
    type: types.REGISTER_ISSUER_ERROR,
    payload: e
  };
}

//UPDATE ISSUER 
export function updateIssuerStart () {
  return {
    type: types.UPDATE_ISSUER_START
  };
}
export function updateIssuerSuccess (res?: any) {
  return {
    type: types.UPDATE_ISSUER_SUCCESS,
    payload: res
  }
}
export function updateIssuerError(e: any) {
  return {
    type: types.UPDATE_ISSUER_ERROR,
    payload: e
  };
}

// GET ISSUER
export function getIssuerStart() {
  return {
    type: types.GET_ISSUER_START
  };
}
export function getIssuerSuccess(res?: any) {
  return {
    type: types.GET_ISSUER_SUCCESS,
    payload: res
  };
}
export function getIssuerError(e: any) {
  return {
    type: types.GET_ISSUER_ERROR,
    payload: e
  };
}

//DELETE ISSUER
export function deleteIssuerStart () {
  return {
    type: types.DELETE_ISSUER_START
  };
}
export function deleteIssuerSuccess (res?: any) {
  return {
    type: types.DELETE_ISSUER_SUCCESS,
    payload: res
  }
}
export function deleteIssuerError(e: any) {
  return {
    type: types.DELETE_ISSUER_ERROR,
    payload: e
  };
}

export function confirmRegisterStart() {
  return {
    type: types.CONFIRM_REGISTER_START
  };
}
export function confirmRegisterSuccess(res?: any) {
  return {
    type: types.CONFIRM_REGISTER_SUCCESS,
    payload: res
  };
}
export function confirmRegisterError(e: any) {
  return {
    type: types.CONFIRM_REGISTER_ERROR,
    payload: e
  };
}

export function resetPasswordRequestStart() {
  return {
    type: types.RESET_PASSWORD_REQUEST_START
  };
}
export function resetPasswordRequestSuccess(res?: any) {
  return {
    type: types.RESET_PASSWORD_REQUEST_SUCCESS,
    payload: res
  };
}
export function resetPasswordRequestError(e: any) {
  return {
    type: types.RESET_PASSWORD_REQUEST_ERROR,
    payload: e
  };
}

export function resetPasswordStart() {
  return {
    type: types.RESET_PASSWORD_START
  };
}
export function resetPasswordSuccess(res?: any) {
  return {
    type: types.RESET_PASSWORD_SUCCESS,
    payload: res
  };
}
export function resetPasswordError(e: any) {
  return {
    type: types.RESET_PASSWORD_ERROR,
    payload: e
  };
}

export function logout() {
  return {
    type: types.LOGOUT
  };
}

export function storeSession(session: any) {
  localStorage.removeItem('jwt');
  localStorage.setItem('jwt', session.accessToken.jwtToken)
  return {
    type: types.STORE_SESSION,
    payload: session
  }
}

export function setUser(user: any) {
  return {
    type: types.SET_USER,
    payload: user
  }
}

